import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Log } from "ng2-logger";
import { ConfirmationModalComponent } from "@components/index";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "@app/authentication/services/authentication.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastsManager } from "@app/shared/util/toastr.service";

@Component({
    selector: 'app-update-bosch-id',
    templateUrl: './update-bosch-id.component.html',
    styleUrls: ['./update-bosch-id.component.scss']
})
export class UpdateBoschIdComponent implements OnInit {
    _logger = Log.create(UpdateBoschIdComponent.name);
    @ViewChild(ConfirmationModalComponent, {static: false}) confirmationModal: ConfirmationModalComponent;
    @ViewChild('form', {static: false}) form: ElementRef;

    updateBoschIdForm: UntypedFormGroup;
    showValidations: boolean;

    inputDisabled = false;

    constructor(private formBuilder: UntypedFormBuilder,
                private authService: AuthenticationService,
                private router: Router,
                private translate: TranslateService,
                private toastr: ToastsManager) {

        this.updateBoschIdForm = this.formBuilder.group({
            'identity': ['', Validators.required],
            'password': ['', Validators.required]
        });
    }

    ngOnInit() {
    }

    onUpdateBoschID() {
        this.inputDisabled = true;
        if (!this.updateBoschIdForm.valid) {
            this.showValidations = true;
        } else {
            this.showValidations = false;
            this.confirmationModal.open();
        }
    }

    onConfirmUpdateBoschID(value) {
        const formData = Object.assign({},
            this.updateBoschIdForm.value,
            {boschId: value.boschId});

        this.authService.updateBoschID(formData).subscribe(
            (data: any) => {
                this._logger.info('handleUpdateBoschID:: API returned data: ', data);
                this.toastr.info(this.translate.instant('auth.toasts.updateBoschIdSuccess'));
                this.confirmationModal.close();
                this.router.navigate(['/auth']);
            },
            (error: any) => {
                this._logger.info('handleUpdateBoschID:: API returned error: ', error);
                this.confirmationModal.close();
            });
    }

    @HostListener('document:click')
    onEnableInput() {
        this.inputDisabled = false;
    }
}
